import * as types from "./../types";

const digiLockerData = {
  gender: "",
  address: [],
  document: [],
  addressSplitStatus:"",
  kycCompletedTimestamp:""
};

const initState = {
  digiLockerData: null,
  error: null,
};

const DigiLockerReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_DIGILOCKER_DATA:
      return {
        ...state,
        digiLockerData: {
          ...digiLockerData,
          gender: action.payload?.gender,
          address: (action.payload?.kycValid && action.payload?.kycValid ==="Y") ? action.payload?.address : "",
          document: action.payload?.document,
          addressConfirmationRequired: action.payload?.addressConfirmationRequired,
          telcoRequiredFlag: action.payload?.telcoRequiredFlag,
          telcoReqBancaFLag: action.payload?.telcoFlag,
          telcoReason: action.payload?.telcoReason,
          addressMatchFlag: action.payload?.addressMatchFlag,
          addressSplitStatus: action.payload?.address?.[0]?.addressSplitStatus,
          kycCompleted: action.payload?.kycCompleted,
          kycValid: action.payload?.kycValid,
          kycCompletedTimestamp: action.payload?.kycCompletedTimestamp
        },
        error: action.payload?.error,
      };
    default:
      return state;
  }
};

export default DigiLockerReducer;
